"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("@hotmart/cosmos/dist/table/table.css");
require("@hotmart/cosmos/dist/table/variations/bordered.css");
require("@hotmart/cosmos/dist/table/variations/borderless.css");
require("@hotmart/cosmos/dist/table/variations/card.css");
require("@hotmart/cosmos/dist/table/variations/hover.css");
require("@hotmart/cosmos/dist/table/variations/large.css");
require("@hotmart/cosmos/dist/table/variations/small.css");
require("@hotmart/cosmos/dist/table/variations/striped.css");
const Table = ({ children, className, size, variation = 'bordered', ...rest }) => {
    const classes = (0, classnames_1.default)('hot-table', {
        [`hot-table--${variation}`]: variation,
        [`hot-tag--${size}`]: size
    }, className);
    return ((0, jsx_runtime_1.jsx)("table", { className: classes, ...rest, children: children }));
};
exports.default = Table;
